import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import "lang/i18n";
import ModalHandler from "modals/handler/ModalHandler";
import NiceModal from "@ebay/nice-modal-react";
import BrowserEventProvider from 'providers/BrowserEventProvider';
import KakaoMapScriptLoader from 'routes/renewal/components/KakaoMapScriptLoader';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ModalHandler();

ReactDOM.render(
  <React.StrictMode>
    <BrowserEventProvider>
      <NiceModal.Provider>
        <KakaoMapScriptLoader />  
        <App />
      </NiceModal.Provider>
    </BrowserEventProvider>
  </React.StrictMode>
  , document.getElementById('root'));